import React from 'react'
import ColorElement from './colorElement'

import './colorMenu.css'

const ColorMenu = ({ colors, selectedPath, selectedColor, onSelectColor, onAddColorScheme, onAddColor, currentColors, selectedTile }) => {
	return (
		<div>
			<div className="seleccione">Seleccione el nuevo Color</div>
			<div id="color-menu">
				{colors.map(( color, index ) => {
					return (
					<ColorElement 
						key={index}
						id={index}
							color={color}
						selected={index === selectedColor}
						selectedPath={selectedPath}
						onClick={onSelectColor}
					/>
					)
				})}
				<ColorElement
					color='white'
					selected={false}
					selectedPath={selectedPath}
					onClick={onSelectColor}/>
			</div>
			<button onClick={() => onAddColorScheme(selectedTile, currentColors)}>Guardar colores</button>
		</div>
	)
}

export default ColorMenu;


// WEBPACK FOOTER //
// ./src/components/mosaic/colorMenu.jsx